const CustomCursor = ({ innerCursor, outerCursor }) => {
  return (
    <div className="hidden md:block">
      <div className="inner--cursor" ref={innerCursor}></div>
      <div className="outer--cursor" ref={outerCursor}></div>
    </div>
  );
};

export default CustomCursor;
